import React from 'react';
import { TrendingDownIcon, SearchIcon, PaletteIcon, CompassIcon, ArrowRightIcon } from 'lucide-react';
import { NordenMascot } from './NordenMascot';
export function ProblemSection() {
  const scrollToContact = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('contact')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative py-24 lg:py-28 bg-surface-muted overflow-hidden" data-id="element-859" data-mp="39hvy4fn71n5c">
      {/* Norden with lightbulb — has the answer */}
      <div className="absolute -bottom-4 right-4 lg:right-8 opacity-80 pointer-events-none hidden xl:block" data-id="element-860" data-mp="35f94qaavju61">
        <NordenMascot variant="lightbulb" size="md" data-id="element-861" data-mp="3jeqyz56xvzms" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-862" data-mp="3egh1up1nmoyj">
        <h2 className="text-3xl lg:text-4xl font-bold text-navy-900 text-center mb-4" data-id="element-863" data-mp="3ef5z8sjy3n90">
          Herkenbaar?
        </h2>
        <p className="text-lg text-slate-600 text-center max-w-2xl mx-auto mb-12 lg:mb-16" data-id="element-864" data-mp="1k37r6txdgxep">
          Veel accountants en financieel adviseurs lopen tegen dezelfde
          problemen aan als ze online willen groeien.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-865" data-mp="oczryocjm57i">
          <div className="bg-white rounded-card shadow-card p-6 lg:p-8 flex items-center gap-4 md:block" data-id="element-866" data-mp="sdjnxoldr2s2">
            <div className="w-12 h-12 rounded-xl bg-accent-light flex items-center justify-center flex-shrink-0 md:mb-5" data-id="element-867" data-mp="x4s1mwtqtab1">
              <TrendingDownIcon className="w-6 h-6 text-accent" data-id="element-868" data-mp="12337kwgx30nz" />
            </div>
            <p className="text-navy-800 font-medium text-lg" data-id="element-869" data-mp="171mxf7ymswlm">
              Je via-via netwerk raakt langzaam uitgeput
            </p>
          </div>

          <div className="bg-white rounded-card shadow-card p-6 lg:p-8 flex items-center gap-4 md:block" data-id="element-870" data-mp="1bzy1t365qewg">
            <div className="w-12 h-12 rounded-xl bg-accent-light flex items-center justify-center flex-shrink-0 md:mb-5" data-id="element-871" data-mp="3dt5leosszio5">
              <SearchIcon className="w-6 h-6 text-accent" data-id="element-872" data-mp="3htz6zbirwldv" />
            </div>
            <p className="text-navy-800 font-medium text-lg" data-id="element-873" data-mp="p08xdgznoq9s">
              Google Ads zijn te duur en leveren slechte leads op
            </p>
          </div>

          <div className="bg-white rounded-card shadow-card p-6 lg:p-8 flex items-center gap-4 md:block" data-id="element-874" data-mp="k30grku5ouan">
            <div className="w-12 h-12 rounded-xl bg-accent-light flex items-center justify-center flex-shrink-0 md:mb-5" data-id="element-875" data-mp="y29tubn2f8ae">
              <PaletteIcon className="w-6 h-6 text-accent" data-id="element-876" data-mp="17z4v32aq3msd" />
            </div>
            <p className="text-navy-800 font-medium text-lg" data-id="element-877" data-mp="17x1trm44e78c">
              Slechte ervaringen met vage marketingbureaus
            </p>
          </div>

          <div className="bg-white rounded-card shadow-card p-6 lg:p-8 flex items-center gap-4 md:block" data-id="element-878" data-mp="1hp7miy274sol">
            <div className="w-12 h-12 rounded-xl bg-accent-light flex items-center justify-center flex-shrink-0 md:mb-5" data-id="element-879" data-mp="1cqwacgofi637">
              <CompassIcon className="w-6 h-6 text-accent" data-id="element-880" data-mp="1qq5o79p5wo40" />
            </div>
            <p className="text-navy-800 font-medium text-lg" data-id="element-881" data-mp="1lrkorchqi8gm">
              Je bent te druk met klantwerk om SEO uit te zoeken
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4 text-center" data-id="element-882" data-mp="2ab61tygqrxyf">
          <span className="text-navy-700 font-medium" data-id="element-883" data-mp="1wc6bmmdkzb05">
            Herken je dit? Wij helpen je verder.
          </span>
          <a href="#contact" onClick={scrollToContact} className="inline-flex items-center gap-2 bg-accent hover:bg-accent-hover text-white font-semibold px-6 py-3 rounded-button shadow-soft hover:shadow-medium transition-all duration-200" data-id="element-884" data-mp="20c71d364r8mi">
            Neem contact op
            <ArrowRightIcon className="w-4 h-4" data-id="element-885" data-mp="1cp8o0edb4gst" />
          </a>
        </div>
      </div>
    </section>;
}